var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacemask = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.673 21.123c-.403-.929-1.117-1.618-2.016-1.941A20.195 20.195 0 0 0 50.775 18a20.21 20.21 0 0 0-6.883 1.182c-.9.323-1.613 1.014-2.017 1.94-.4.925-.432 2-.086 2.952l4.545 12.438v8.422l.002.024c0 .007-.002.014 0 .023l.808 16.313C47.247 63.371 48.841 65 50.775 65c1.934 0 3.528-1.627 3.631-3.706l.809-16.313c0-.007-.003-.014 0-.023l.002-.024v-8.42l4.544-12.44a4.024 4.024 0 0 0-.086-2.951h-.002ZM47.97 37.228h5.609v6.824h-5.61v-6.824ZM52.774 61.2c-.056 1.144-.934 2.038-1.999 2.038-1.064 0-1.942-.895-1.999-2.038l-.762-15.387h5.52l-.761 15.387h.001Zm5.465-37.77L53.84 35.468h-.892l1.033-6.847c.071-.479-.231-.93-.676-1.01-.448-.079-.865.249-.939.728l-1.075 7.126h-1.033l-1.076-7.126c-.073-.479-.493-.807-.938-.728-.445.08-.748.53-.676 1.01l1.033 6.847h-.893l-4.397-12.039a2.107 2.107 0 0 1 .044-1.563c.21-.486.586-.847 1.054-1.017a18.682 18.682 0 0 1 6.363-1.089c2.218 0 4.36.366 6.363 1.09.468.169.844.53 1.054 1.016.217.497.231 1.053.046 1.563h.003ZM38.184 45.584h-.233v-5.728c0-.486-.366-.879-.817-.879h-.561v-7.786c0-1.19-.494-2.3-1.355-3.048l-3.376-2.933c-.82-.712-1.92-.852-2.873-.361-.951.49-1.541 1.498-1.541 2.632v11.496h-.561c-.452 0-.817.393-.817.88v5.727h-.233c-.452 0-.817.393-.817.879v15.502c0 1.67 1.264 3.03 2.816 3.03h8.37c1.552 0 2.816-1.36 2.816-3.03V46.463c0-.486-.365-.88-.816-.88h-.002Zm-9.12-18.103c0-.457.228-.848.61-1.044a.996.996 0 0 1 1.14.142l3.377 2.933a2.21 2.21 0 0 1 .746 1.679v7.786h-5.874V27.481Zm-1.38 13.256h8.633v4.847h-8.633v-4.847Zm9.683 21.23c0 .7-.53 1.27-1.18 1.27h-8.37c-.652 0-1.18-.57-1.18-1.27V47.344h10.732v14.623h-.002Z",
    fill: "currentColor"
  }))));
};
export { SvgFacemask as ReactComponent };